import * as React from 'react';

import { Grid, Box } from '@mui/material';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { Description } from '@mui/icons-material';

import Typography from '@mui/material/Typography';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';

function RequestList() {
    const [type, setType] = React.useState('');
    const handleChange = (event) => {
        setType(event.target.value);
    };

    const [category, setCategory] = React.useState('');
    const handleChange2 = (event) => {
        setCategory(event.target.value);
    };

    const requests = [
        {title:'Netowrk Engineer', type: 'type 1', category: 'category 1', publish_date: '12/11/2024', description: 'description 1'},
        {title:'APEX Engineer', type: 'type 2', category: 'category 2', publish_date: '13/11/2024', description: 'description 2'},
        {title:'IT Engineer', type: 'type 3', category: 'category 3', publish_date: '14/11/2024', description: 'description 3'},
        {title:'Netowrk Engineer', type: 'type 1', category: 'category 1', publish_date: '12/11/2024', description: 'description 1'},
        {title:'APEX Engineer', type: 'type 2', category: 'category 2', publish_date: '13/11/2024', description: 'description 2'},
        {title:'IT Engineer', type: 'type 3', category: 'category 3', publish_date: '14/11/2024', description: 'description 3'},
        {title:'Netowrk Engineer', type: 'type 1', category: 'category 1', publish_date: '12/11/2024', description: 'description 1'},
        {title:'APEX Engineer', type: 'type 2', category: 'category 2', publish_date: '13/11/2024', description: 'description 2'},
        {title:'IT Engineer', type: 'type 3', category: 'category 3', publish_date: '14/11/2024', description: 'description 3'},
        {title:'Netowrk Engineer', type: 'type 1', category: 'category 1', publish_date: '12/11/2024', description: 'description 1'},
        {title:'APEX Engineer', type: 'type 2', category: 'category 2', publish_date: '13/11/2024', description: 'description 2'},
        {title:'IT Engineer', type: 'type 3', category: 'category 3', publish_date: '14/11/2024', description: 'description 3'},
    ]

    return (
        <DashboardLayout >
        <DashboardNavbar />
        <MDBox py={2}>
            <MDBox px={2} mx={2} mt={2}>
            <Grid container spacing={3}>
                
                <Grid item xs={12} >
                    <MDBox mb={-2}>
                        <Grid
                        
                        spacing={2}
                        sx={{
                            backgroundColor: 'lightgray', // Change to your desired background color
                            padding: 2,  // Optional: to add some padding inside the grid container
                            borderRadius: 1,  // Optional: to give rounded corners to the container
                            '& .MuiGrid-item': { // Target all Grid items inside this container
                            paddingLeft: '2px', // Negative padding on all items
                            paddingTop:'2px'
                            },
                            
                        }}
                        >
                        <Grid item xs={12} md={6} lg={4}>
                            <MDTypography variant="h4" fontWeight="regular" color="text">
                            Requesta
                            </MDTypography>
                        </Grid>
                        </Grid>

                    </MDBox>
                </Grid>
                
                <Grid  xs={12} pl={3} mt={4}>
                    <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'space-between'}>
                        <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-start'}>
                            <h3>Elenco Annunci</h3>
                        </Stack>
                        <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                            <div>
                                <Button variant="contained">
                                    <a style={{color: 'white'}}>CREA NUOVO ANNUNCIO</a>
                                </Button>
                            </div>
                        </Stack>

                    </Stack>
                </Grid>
                
                <Grid  xs={12} pl={3} mt={4}>
                    <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'space-between'}>
                        
                        <Stack sx={{ display: 'flex', alignItems: 'center', width: '100%' }} spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                            <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%' }}
                            >
                                <IconButton sx={{ p: '10px' }} aria-label="menu">
                                <SearchIcon />
                                </IconButton>
                                <InputBase
                                    sx={{ ml: 1, flex: 1, width: '100%'}}
                                    placeholder="Search Google Maps"
                                    inputProps={{ 'aria-label': 'search google maps' }}
                                />
                                
                            </Paper>
                        </Stack>

                    </Stack>
                </Grid>

                <Grid  xs={12} pl={3} mt={4}>
                    <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'space-between'}>
                        <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-start'}>
                            <Button sx={{backgroundColor:'#9d9d9d'}} variant="contained">
                                <a style={{color:'white'}}>Propane</a>
                            </Button>
                            <Button sx={{backgroundColor:'#9d9d9d'}}  variant="contained">
                                <a style={{color:'white'}}>Cerca</a>
                            </Button>

                            <FormGroup>
                                <FormControlLabel control={<Switch color={'primary'} defaultChecked />} label="Tutti gli annunci" />
                            </FormGroup>

                            <FormGroup>
                                <FormControlLabel control={<Switch color={'primary'} defaultChecked />} label="I miei annunci" />
                            </FormGroup>
                        </Stack>
                        <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                            <div>
                                <a>Filtra per</a>
                                <Button variant="text">Tipologia</Button>
                            </div>
                        </Stack>

                    </Stack>
                </Grid>

                <Grid  xs={12} pl={3} mt={4}>
                    <Grid item xs={12} >

                        {
                            requests.map((request) => (
                                <Grid item xs={4} sx={{display: 'inline-block', width: '100%'}} >
                                    <MDBox px={3} py={2} m={1} sx={{borderRadius: 3, background:'white'}} mb={1}>
                                        <Grid item xs={12} >

                                            <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-end'}>
                                                <CheckCircleIcon sx={{color:'green'}}/> 
                                                <Button variant="text">Dettaglio</Button>
                                            </Stack>

                                        </Grid>
                                        <Grid item xs={12} >

                                            <Stack spacing={2} direction="row" alignItems={'center'} justifyContent={'flex-start'}>
                                                
                                                <Button sx={{background: '#04054C'}} size={"small"} variant="contained">
                                                    <a style={{color: 'white'}}>Propane</a>
                                                </Button>
                                                <Button sx={{background:'#4A60AE'}} size={"small"} variant="contained">
                                                    <a style={{color: 'white'}}>T & M</a>
                                                </Button>
                                            </Stack>
                                    
                                        </Grid>
                                        <Grid item xs={12} >

                                            <Stack mt={2} spacing={2} direction="column" alignItems={'flex-start'} justifyContent={'flex-start'}>
                                                <h3 >{request.title}</h3>
                                            </Stack>

                                            <Stack spacing={2} direction="column" alignItems={'flex-start'} justifyContent={'flex-start'}>
                                                <Typography variant="body2" gutterBottom>
                                                {request.description}
                                                </Typography>
                                            </Stack>
                                            
                                            <Stack mt={2} spacing={2} direction="row" alignItems={'flex-start'} justifyContent={'flex-start'}>
                                                <Typography sx={{fontWeight: 'bold', color: '#9d9d9d'}} variant="body2" gutterBottom >Pubblicato il: {request.publish_date}</Typography>
                                                <Typography sx={{fontWeight: 'bold', color: '#9d9d9d'}} variant="body2" gutterBottom >Dove: Milano e/ o remoto</Typography>
                                            </Stack>
                                    
                                        </Grid>
                                    </MDBox>
                                </Grid>
                            ))
                        }
                    
                    </Grid>
                </Grid>
                
            </Grid>
            </MDBox>
            
        </MDBox>
        <Footer />
        </DashboardLayout>
    );
}

export default RequestList;
